import { BaseDataService } from './base-data.service'
import {
  CREATE_MERCHANT,
  UPDATE_MERCHANT
} from '../definitions/merchant-definitions'

export class MerchantDataService {
  constructor(private baseDataService: BaseDataService) {}

  createMerchant(input) {
    return this.baseDataService.mutate(CREATE_MERCHANT, {
      input
    })
  }

  updateMerchant(input) {
    return this.baseDataService.mutate(UPDATE_MERCHANT, {
      input
    })
  }
}
